import {takeEvery} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeEvery(ACTION.CREATE_PRODUCT_RETURN.REQUEST, saga.createProductReturn);
}
